import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const SEO2025Strategies = ({ name }) => {
  const [showScroll, setShowScroll] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    // Scroll to top on mount or when name changes
    window.scrollTo(0, 0);
  }, [name]);

  useEffect(() => {
    // Initialize WOW.js for animations (if present)
    if (typeof window !== 'undefined' && window.WOW) {
      new window.WOW().init();
    }

    // Google Analytics
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag('js', new Date());
      gtag('config', 'G-P2TS4436R5');
    }
  }, []);

  // Scroll progress + back-to-top visibility
  useEffect(() => {
    const handleScrollProgress = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const progress =
        scrollHeight > 0 ? (scrollTop / scrollHeight) * 307.919 : 0;

      setScrollProgress(progress);
      setShowScroll(scrollTop > 300);
    };

    window.addEventListener('scroll', handleScrollProgress);
    handleScrollProgress();

    return () => window.removeEventListener('scroll', handleScrollProgress);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80; // Adjust for fixed navbar height
      const elementPosition =
        element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth',
      });
    }
  };

  const scrollToTop = () =>
    window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div className="min-h-screen bg-gray-50">
      <Helmet>
        <title>Boost Google Rankings with 2025 SEO Strategies</title>
        <meta
          name="description"
          content="Discover the most effective SEO strategies. Learn how focusing on search intent optimization, topical authority SEO and multimedia SEO can help your website outrank competitors and stay ahead in search results."
        />
        <link
          rel="canonical"
          href="https://www.securxperts.com/ai-digital-marketing"
        />
      </Helmet>

      {/* Navbar */}
      <Navbar />

      {/* Hero Section with Banner Image */}
      <header className="relative w-full">
        <div
          className="relative w-full h-64 sm:h-80 md:h-96 lg:h-[420px] bg-center bg-cover bg-no-repeat"
          style={{ backgroundImage: "url('../img/boost.jpg')" }}
        >
          {/* Dark overlay */}
          <div className="absolute inset-0  bg-opacity-60" />

          {/* Text content */}
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white px-4">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-center">
              Boost Google Rankings with 2025 SEO Strategies
            </h1>
            <div className="flex items-center gap-2 text-sm sm:text-base">
              <Link to="/" className="hover:underline">
                Home
              </Link>
              <svg
                width="7"
                height="10"
                viewBox="0 0 7 10"
                fill="none"
                className="mt-1"
              >
                <path
                  d="M0.297 0.262C0.105 0.426 -0.002 0.648 0 0.878C0.002 1.109 0.113 1.329 0.308 1.492L4.02 4.604L0.366 7.711C0.173 7.875 0.067 8.097 0.069 8.328C0.071 8.558 0.182 8.778 0.377 8.941C0.474 9.022 0.59 9.086 0.717 9.13C0.844 9.174 0.981 9.196 1.118 9.195C1.255 9.194 1.391 9.171 1.518 9.126C1.644 9.081 1.758 9.016 1.854 8.933L6.232 5.212C6.329 5.131 6.405 5.034 6.457 4.927C6.509 4.821 6.535 4.706 6.534 4.591C6.533 4.476 6.505 4.362 6.451 4.256C6.397 4.15 6.319 4.054 6.221 3.974L1.774 0.254C1.677 0.173 1.561 0.109 1.434 0.065C1.307 0.021 1.171 -0.001 1.033 0C0.896 0.001 0.76 0.024 0.634 0.069C0.507 0.114 0.393 0.18 0.297 0.262Z"
                  fill="white"
                />
              </svg>
              <span>Boost Google Rankings with 2025 SEO Strategies</span>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content with Sidebar */}
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-16 py-16 lg:py-24 bg-gradient-to-b from-gray-50 to-gray-100 rounded-3xl shadow-md">
        <div className="flex flex-col lg:flex-row lg:gap-12">
          {/* Main Content */}
          <article className="lg:w-3/4 space-y-12">
            {/* Intro Block */}
            <header className="text-center mb-12">
              <h1
                className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 tracking-tight drop-shadow-md animate-fadeIn"
                data-wow-delay="0.1s"
              >
                Boost Google Rankings with 2025 SEO Strategies
              </h1>
              <p
                className="text-base sm:text-lg text-gray-600 mt-4 max-w-3xl mx-auto leading-relaxed animate-fadeIn"
                data-wow-delay="0.2s"
              >
                As we move into the modern era,{' '}
                
        SEO Strategies
      
                in 2025 are more dynamic than ever. With Google’s evolving algorithms and changing user behaviors, it’s
                essential to focus on strategies that deliver long-term value and sustainable results. This guide
                uncovers the SEO strategies 2025 that will keep you climbing the rankings—while avoiding outdated
                practices that no longer work.
              </p>
              <p className="text-base sm:text-lg text-gray-600 mt-3 max-w-3xl mx-auto leading-relaxed">
                Whether you’re a business owner, marketer or content creator, these insights will help keep your site
                competitive, visible and aligned with how people search today.
              </p>

              {/* Overview Image Placeholder */}
              <div className="image-placeholder mt-8 flex justify-center">
                <img
                  src="/img/blog51.jpg"
                  alt="Overview of 2025 SEO strategies to boost Google rankings"
                />
              </div>
            </header>

            {/* 1. Introduction */}
            <section
              id="introduction"
              className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 bg-gradient-to-br from-gray-50 to-gray-100 hover:shadow-xl transition-all duration-300 animate-slideUp"
              data-wow-delay="0.3s"
            >
              <h2 className="text-2xl sm:text-3xl font-bold text-blue-600 mb-4">
                Introduction
              </h2>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
                As we move into 2025, SEO is no longer just about keywords and backlinks. It’s about understanding user
                intent, building authority and delivering value across different content formats. Google’s algorithms
                prioritize helpful, reliable content that answers real questions and provides a great on-page experience.
              </p>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed mt-3">
                In this guide, you’ll learn which{' '}
              
        SEO Strategies
      
               
                are working in 2025, which outdated tactics to avoid and how to use proven tools and techniques to
                improve your rankings sustainably.
              </p>
            </section>

            {/* 2. What’s Working in SEO for 2025 */}
            <section
              id="whats-working"
              className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 bg-gradient-to-br from-gray-50 to-gray-100 hover:shadow-xl transition-all duration-300 animate-slideUp"
              data-wow-delay="0.3s"
            >
              <h2 className="text-2xl sm:text-3xl font-bold text-blue-600 mb-4">
                What’s working in SEO for 2025
              </h2>

              {/* 2.1 Search Intent Optimization */}
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mt-4">
                1. Prioritize Search Intent Optimization, Not Just Keywords
              </h3>
              <p className="text-base sm:text-lg text-gray-700 mt-2 leading-relaxed">
                Modern SEO in 2025 is less about matching exact keyword phrases and more about deeply understanding what
                your audience wants to achieve. Instead of writing for search engines, focus on answering user intent
                clearly and completely.
              </p>
              <p className="text-base sm:text-lg text-gray-700 mt-3 leading-relaxed">
                Align your content to satisfy different user intents:
              </p>
              <ul className="list-disc pl-6 text-base sm:text-lg text-gray-700 mt-2 space-y-2">
                <li>Informational: “How to select a CRM in 2025”</li>
                <li>Comparative: “Best tools for local SEO this year”</li>
                <li>Transactional: “Affordable SEO services for small businesses”</li>
              </ul>

              {/* 2.2 Generative Experience */}
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mt-6">
                2. Optimize for the Generative Experience
              </h3>
              <p className="text-base sm:text-lg text-gray-700 mt-2 leading-relaxed">
                With Google’s Search Generative Experience (SGE), users increasingly see AI-powered summaries alongside
                traditional search results. To stand out in this environment, your content must be structured and
                highly useful.
              </p>
              <ul className="list-disc pl-6 text-base sm:text-lg text-gray-700 mt-2 space-y-2">
                <li>Structure your content with clear sections, bullet points and FAQs</li>
                <li>
                  Offer actionable data, real-life examples and{' '}
                  <strong>
                    <em>
                      <a
                        href="https://www.securxperts.com/our-services"
                        className="text-blue-600 hover:text-blue-800 transition-colors"
                      >
                        step-by-step guides
                      </a>
                    </em>
                  </strong>
                </li>
                <li>Format your information for easy scanning on mobile and desktop</li>
              </ul>

              {/* 2.3 Topical Authority / Content Clusters */}
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mt-6">
                3. Build Topical Authority SEO with Content Clusters
              </h3>
              <p className="text-base sm:text-lg text-gray-700 mt-2 leading-relaxed">
                Google rewards comprehensive websites that demonstrate expertise across related topics. Instead of
                relying on a single blog post, create interconnected content clusters that cover a topic in depth.
              </p>
              <p className="text-base sm:text-lg text-gray-700 mt-3 leading-relaxed">
                For stronger SEO strategies 2025, think in terms of:
              </p>
              <ul className="list-disc pl-6 text-base sm:text-lg text-gray-700 mt-2 space-y-2">
                <li>Main page: “Comprehensive SEO Services 2025”</li>
                <li>
                  Supporting blogs: “Understanding Technical SEO”, “Best Local SEO Practices” and “2025 Link Building
                  Tactics”
                </li>
              </ul>

              {/* 2.4 Multimedia SEO */}
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mt-6">
                4. Elevate Multimedia SEO (Voice, Visual & Video)
              </h3>
              <p className="text-base sm:text-lg text-gray-700 mt-2 leading-relaxed">
                Searching by voice, image and video is rising fast. To keep up with the latest SEO strategies 2025, your
                content should be optimized across multiple formats, not just text.
              </p>
              <ul className="list-disc pl-6 text-base sm:text-lg text-gray-700 mt-2 space-y-2">
                <li>Add descriptive alt text to all images</li>
                <li>Use captions and transcripts in your videos</li>
                <li>
                  Answer queries conversationally so your content performs well for multimedia SEO and voice search
                  readiness
                </li>
              </ul>

              {/* 2.5 E-E-A-T */}
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mt-6">
                5. Build Trust with E-E-A-T SEO (Experience, Expertise, Authoritativeness & Trustworthiness)
              </h3>
              <p className="text-base sm:text-lg text-gray-700 mt-2 leading-relaxed">
                Google emphasizes authentic, expert-driven content. To build strong E-E-A-T:
              </p>
              <ul className="list-disc pl-6 text-base sm:text-lg text-gray-700 mt-2 space-y-2">
                <li>Showcase authors with bios, credentials and real-world experience</li>
                <li>Share client testimonials, reviews and case studies</li>
                <li>Use original photos, data and documentation instead of stock or generic content</li>
              </ul>

              {/* Image Placeholder – What's Working */}
              <div className="image-placeholder my-5 flex justify-center">
                <img
                  src="/img/blog52.jpg"
                  alt="SEO strategies that work in 2025"
                />
              </div>
            </section>

            {/* Outdated Practices to Avoid */}
            <section
              id="outdated-practices"
              className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 bg-gradient-to-br from-gray-50 to-gray-100 hover:shadow-xl transition-all duration-300 animate-slideUp"
              data-wow-delay="0.3s"
            >
              <h2 className="text-2xl sm:text-3xl font-bold text-blue-600 mb-4">
                Out dated practices to avoid in 2025
              </h2>
              <ul className="list-disc pl-6 text-base sm:text-lg text-gray-700 space-y-3">
                <li>
                  <strong>Keyword Stuffing:</strong> Overusing keywords damages your credibility and user experience.
                  Instead, write naturally and use related terms contextually.
                </li>
                <li>
                  <strong>Spammy Backlinks:</strong> Low-quality, irrelevant links can harm your rankings. Focus on
                  trusted partnerships, guest blogging and PR citations.
                </li>
                <li>
                  <strong>Unedited AI Content:</strong> Mass-produced, generic articles are increasingly filtered out by
                  Google. Always review, personalize and enrich AI-generated content.
                </li>
                <li>
                  <strong>Neglecting Videos & Images:</strong> Text-only content is no longer enough. Diversify with
                  multimedia and optimize every visual asset.
                </li>
              </ul>

              {/* Image Placeholder – Outdated Practices */}
              <div className="image-placeholder my-5 flex justify-center">
                <img
                  src="/img/blog53.jpg"
                  alt="Outdated SEO practices to avoid"
                />
              </div>
            </section>

            {/* Essential SEO Tools */}
            <section
              id="seo-tools"
              className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 bg-gradient-to-br from-gray-50 to-gray-100 hover:shadow-xl transition-all duration-300 animate-slideUp"
              data-wow-delay="0.3s"
            >
              <h2 className="text-2xl sm:text-3xl font-bold text-blue-600 mb-4">
                Essential SEO Tools for 2025
              </h2>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-3">
                The right tools make it easier to apply these strategies at scale. Here are some must-have platforms for
                SEO in 2025:
              </p>

              <div className="overflow-x-auto">
                <table className="w-full border-collapse mt-4 bg-gray-50 rounded-lg shadow-sm">
                  <thead>
                    <tr className="bg-blue-100 border border-blue-200">
                      <th className="p-4 text-left text-base sm:text-lg font-semibold text-gray-800">
                        Tool
                      </th>
                      <th className="p-4 text-left text-base sm:text-lg font-semibold text-gray-800">
                        What It’s Best For
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-blue-200 hover:bg-blue-50 transition-colors duration-300">
                      <td className="p-4 text-base sm:text-lg text-gray-700">
                        Google Search Console
                      </td>
                      <td className="p-4 text-base sm:text-lg text-gray-700">
                        Monitor and improve site performance
                      </td>
                    </tr>
                    <tr className="border-b border-blue-200 hover:bg-blue-50 transition-colors duration-300">
                      <td className="p-4 text-base sm:text-lg text-gray-700">Frase.io</td>
                      <td className="p-4 text-base sm:text-lg text-gray-700">
                        Craft intent-based, optimized content
                      </td>
                    </tr>
                    <tr className="border-b border-blue-200 hover:bg-blue-50 transition-colors duration-300">
                      <td className="p-4 text-base sm:text-lg text-gray-700">Surfer SEO</td>
                      <td className="p-4 text-base sm:text-lg text-gray-700">
                        Analyze and enhance on-page SEO with SERP insights
                      </td>
                    </tr>
                    <tr className="border-b border-blue-200 hover:bg-blue-50 transition-colors duration-300">
                      <td className="p-4 text-base sm:text-lg text-gray-700">SEMrush</td>
                      <td className="p-4 text-base sm:text-lg text-gray-700">
                        Track keywords, competitors and perform technical audits
                      </td>
                    </tr>
                    <tr className="border-b border-blue-200 hover:bg-blue-50 transition-colors duration-300">
                      <td className="p-4 text-base sm:text-lg text-gray-700">NeuronWriter</td>
                      <td className="p-4 text-base sm:text-lg text-gray-700">
                        Create content geared for advanced search engines
                      </td>
                    </tr>
                    <tr className="hover:bg-blue-50 transition-colors duration-300">
                      <td className="p-4 text-base sm:text-lg text-gray-700">
                        AnswerThePublic
                      </td>
                      <td className="p-4 text-base sm:text-lg text-gray-700">
                        Find trending questions and user concerns
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Image Placeholder – Tools */}
              <div className="image-placeholder my-5 flex justify-center">
                <img
                  src="/img/blog54.jpg"
                  alt="Essential SEO tools for 2025"
                />
              </div>
            </section>

            {/* Actionable SEO Tips */}
            <section
              id="actionable-tips"
              className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 bg-gradient-to-br from-gray-50 to-gray-100 hover:shadow-xl transition-all duration-300 animate-slideUp"
              data-wow-delay="0.3s"
            >
              <h2 className="text-2xl sm:text-3xl font-bold text-blue-600 mb-4">
                Actionable SEO tips for success in 2025
              </h2>
              <ul className="list-disc pl-6 text-base sm:text-lg text-gray-700 space-y-2">
                <li>Write for real people, not robots—engage and inform your audience.</li>
                <li>Use simple language, clear headings and clean formatting.</li>
                <li>
                  Address actual user questions with depth and clarity using modern SEO strategies 2025, not shortcuts.
                </li>
                <li>
                  Enrich posts with images, infographics and video for better multimedia SEO and engagement.
                </li>
                <li>Optimize site speed and prioritize mobile responsiveness.</li>
                <li>Consistently update older content to reflect the latest trends and search behavior.</li>
              </ul>

              {/* Image Placeholder – Tips */}
              <div className="image-placeholder my-5 flex justify-center">
                <img
                  src="/img/blog55.jpg"
                  alt="Actionable SEO tips for 2025"
                />
              </div>
            </section>

            {/* Conclusion */}
            <section
              id="conclusion"
              className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 bg-gradient-to-br from-gray-50 to-gray-100 hover:shadow-xl transition-all duration-300 animate-slideUp"
              data-wow-delay="0.3s"
            >
              <h2 className="text-2xl sm:text-3xl font-bold text-blue-600 mb-4">
                Conclusion
              </h2>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-3">
                <strong>
                  <em>
                   <Link
        to="../data-analytics-services"
        className="text-blue-600 hover:text-blue-800 transition-colors"
      >
        SEO Strategies
      </Link>
                  </em>
                </strong>{' '}
                in 2025 are all about delivering clarity, trust and value at every step. By embracing approaches that
                focus on intent, authority, multimedia and genuine expertise, you’ll not only rise in the rankings but
                also earn ongoing credibility with your audience.
              </p>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-3">
                Build your SEO foundation on ethical, proven methods and the rewards are long-lasting. Over time, your{' '}
                <strong>
                  <em>
                    <a
                      href="https://www.securxperts.com/our-services"
                      className="text-blue-600 hover:text-blue-800 transition-colors"
                    >
                      digital presence
                    </a>
                  </em>
                </strong>{' '}
                will grow stronger, more visible and more resilient to algorithm changes.
              </p>
            </section>

            {/* Common Questions */}
            <section
              id="common-questions"
              className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 bg-gradient-to-br from-gray-50 to-gray-100 hover:shadow-xl transition-all duration-300 animate-slideUp"
              data-wow-delay="0.3s"
            >
              <h2 className="text-2xl sm:text-3xl font-bold text-blue-600 mb-4">
                Common questions on SEO Strategies
              </h2>
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
                    What are SEO strategies?
                  </h3>
                  <p className="text-base sm:text-lg text-gray-700 mt-2 leading-relaxed">
                    SEO strategies are planned techniques used to improve a website’s visibility in search engine
                    results. These include on-page SEO, keyword research, link building, technical SEO and content
                    optimization.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
                    Why are SEO strategies important in 2025?
                  </h3>
                  <p className="text-base sm:text-lg text-gray-700 mt-2 leading-relaxed">
                    SEO strategies in 2025 are crucial due to evolving algorithms, AI-powered search and changing user
                    intent. Staying updated helps websites rank higher, drive more traffic and stay ahead of competitors.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
                    What is the best SEO strategy for 2025?
                  </h3>
                  <p className="text-base sm:text-lg text-gray-700 mt-2 leading-relaxed">
                    The best strategy combines high-quality, AI-optimized content with strong Core Web Vitals, structured
                    data and niche-relevant backlinks. Together, these improve visibility, relevance and site experience.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
                    How do I create an effective SEO strategy?
                  </h3>
                  <p className="text-base sm:text-lg text-gray-700 mt-2 leading-relaxed">
                    Start with keyword research, perform a technical audit, optimize content for user intent, build
                    quality backlinks and track results using reliable SEO tools like Google Search Console and Semrush.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
                    Is local SEO still important in 2025?
                  </h3>
                  <p className="text-base sm:text-lg text-gray-700 mt-2 leading-relaxed">
                    Yes. Local SEO helps small businesses show up in local search results, Google Maps and voice
                    searches—making it especially effective for reaching nearby customers in 2025.
                  </p>
                </div>
              </div>
            </section>
          </article>

          {/* Sidebar */}
          <aside className="lg:w-1/4 mt-12 lg:mt-0">
            <div className="sticky top-24 bg-white rounded-2xl shadow-lg p-8 bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200">
              <h3 className="text-xl font-semibold text-gray-800 mb-6">
                Quick Navigation
              </h3>
              <ul className="space-y-4">
                {[
                  { id: 'introduction', label: 'Introduction' },
                  { id: 'whats-working', label: 'What’s Working in 2025' },
                  { id: 'outdated-practices', label: 'Outdated Practices' },
                  { id: 'seo-tools', label: 'Essential SEO Tools' },
                  { id: 'actionable-tips', label: 'Actionable SEO Tips' },
                  { id: 'conclusion', label: 'Conclusion' },
                  { id: 'common-questions', label: 'Common Questions' },
                ].map((item, index) => (
                  <li
                    key={item.id}
                    className="animate-slideInRight"
                    data-wow-delay={`${0.1 * index}s`}
                  >
                    <button
                      onClick={() => scrollToSection(item.id)}
                      className="text-blue-600 hover:text-blue-800 transition-colors text-base font-medium hover:bg-blue-100 rounded-md px-3 py-2 w-full text-left hover:shadow-md"
                    >
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </div>

      {/* Footer */}
      <Footer />

      {/* Scroll to Top with Progress Ring */}
      {showScroll && (
        <div
          onClick={scrollToTop}
          className="scroll-top fixed bottom-6 right-6 z-50 cursor-pointer flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 shadow-lg hover:from-blue-600 hover:to-blue-800 transition-all"
        >
          <svg
            className="progress-circle -rotate-90 w-12 h-12 absolute"
            viewBox="-1 -1 102 102"
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              fill="none"
              stroke="white"
              strokeWidth="4"
              strokeDasharray="307.919"
              strokeDashoffset={307.919 - scrollProgress}
              style={{ transition: 'stroke-dashoffset 0.1s linear' }}
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6 text-white relative z-10"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
          </svg>
        </div>
      )}

      <style jsx>{`
        @keyframes slideInDown {
          0% {
            opacity: 0;
            transform: translateY(-20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes fadeIn {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
        @keyframes slideUp {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes slideInRight {
          0% {
            opacity: 0;
            transform: translateX(20px);
          }
          100% {
            opacity: 1;
            transform: translateX(0);
          }
        }
        @keyframes gradientShift {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }
        .animate-gradientShift {
          background-size: 200% 200%;
          animation: gradientShift 8s ease infinite;
        }
        a,
        .link {
          text-decoration: none;
        }
        .image-placeholder {
          margin: 20px 0;
          display: flex;
          justify-content: center;
        }
        .image-placeholder img {
          max-width: 500px;
          height: auto;
          object-fit: cover;
          border-radius: 10px;
        }
        @media (max-width: 768px) {
          .image-placeholder img {
            max-width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default SEO2025Strategies;
